const initialState = 0;

export default (state = initialState, action) => {
  switch (action.type) {
    case 'inFlightRequests/INCREMENT': {
      return state + 1;
    }

    case 'inFlightRequests/DECREMENT': {
      return state - 1;
    }

    default:
      return state;
  }
};
